import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import logo from '../assets/carousel/1.jpg'

export default function Header() {
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <header className="w-full mt-2">
      <nav className="hidden md:flex gap-5 justify-between items-center w-full px-6 mb-1">
        <div className="bg-[#FDAF74] w-[45px] h-[45px] rounded-[100%] text-xl font-bold overflow-hidden">
          <img src={logo} alt='img'/>
        </div>
        <ul className="flex flex-wrap text-[18px] gap-10 items-center font-medium font-abhaya">
          <li>
            <Link to="/" className="hover:text-orange-600">
              Home
            </Link>
          </li>
          <li>
            <Link to="/gallery" className="hover:text-orange-600">
              Gallery
            </Link>
          </li>
          {/* <li>
            <Link to="/events" className="hover:text-orange-600">
              Past & Upcoming Events
            </Link>
          </li> */}
          <li>
            <a
              onClick={(e) => {
                e.preventDefault();
                navigate('/#footer');
              }}
              href="/#footer"
              className="hover:text-orange-600"
            >
              Aarti Timings
            </a>
          </li>
          <li>
            <Link to="/calendar" className="hover:text-orange-600">
              Event Calendar
            </Link>
          </li>
          <li>
            <a
              onClick={(e) => {
                e.preventDefault();
                navigate('/#about');
              }}
              href="/#about"
              className="hover:text-orange-600"
            >
              About Us
            </a>
          </li>
          <li>
            <a
              onClick={(e) => {
                e.preventDefault();
                navigate('/#contact');
              }}
              href="/#contact"
              className="hover:text-orange-600"
            >
              Contact Us
            </a>
          </li>
        </ul>
        <button
          className="w-[150px] h-[30px] bg-gradient-to-r from-[#E66526] to-[#BE3D23] text-white px-6 rounded-[15px] shadow-md hover:shadow-lg transition-shadow duration-200 font-abhaya text-[18px]"
          onClick={(e) => {
            e.preventDefault();
            window.location.href =
              'https://www.zeffy.com/en-US/donation-form/24b738b0-cf34-482f-a60d-769449ff1f77';
          }}
        >
          Donate
        </button>
      </nav>

      <nav className="flex md:hidden justify-between items-center w-full px-5 py-2">
        <div className="bg-[#FDAF74] w-[45px] h-[45px] rounded-[100%] text-xl font-bold ml-[-10px] overflow-hidden">
        <img src={logo} alt='img'/>
        </div>
        <button
          onClick={toggleMobileMenu}
          className="text-gray-800 text-3xl focus:outline-none"
        >
          ☰
        </button>
      </nav>

      {isMobileMenuOpen && (
        <div className="absolute top-0 left-0 w-full h-screen bg-[#9b2912f1] z-50 flex flex-col p-6 text-left">
          <button
            onClick={toggleMobileMenu}
            className="self-end text-gray-800 text-3xl mb-4"
          >
            ✕
          </button>
          <ul className="flex flex-col gap-4 font-medium font-abhaya">
            <li className="bg-[#f9d598] px-2 py-1 rounded-[10px] ">
              <Link
                to="/"
                className="hover:text-orange-600"
                onClick={toggleMobileMenu}
              >
                Home
              </Link>
            </li>
            <li className="bg-[#f9d598] px-2 py-1 rounded-[10px] ">
              <Link
                to="/gallery"
                className="hover:text-orange-600"
                onClick={toggleMobileMenu}
              >
                Gallery
              </Link>
            </li>
            {/* <li className="bg-[#f9d598] px-2 py-1 rounded-[10px] ">
              <Link
                to="/events"
                className="hover:text-orange-600"
                onClick={toggleMobileMenu}
              >
                Past & Upcoming Events
              </Link>
            </li> */}
            <li className="bg-[#f9d598] px-2 py-1 rounded-[10px] ">
              <a
                onClick={(e) => {
                  e.preventDefault();
                  navigate('/#footer');
                  toggleMobileMenu();
                }}
                href="/#footer"
                className="hover:text-orange-600"
              >
                Aarti Timings
              </a>
            </li>
            <li className="bg-[#f9d598] px-2 py-1 rounded-[10px] ">
              <Link
                to="/calendar"
                className="hover:text-orange-600"
                onClick={toggleMobileMenu}
              >
                Event Calendar
              </Link>
            </li>
            <li className="bg-[#f9d598] px-2 py-1 rounded-[10px] ">
              <a
                href="/#about"
                className="hover:text-orange-600"
                onClick={(e) => {
                  e.preventDefault();
                  navigate('/#about');
                  toggleMobileMenu();
                }}
              >
                About Us
              </a>
            </li>
            <li className="bg-[#f9d598] px-2 py-1 rounded-[10px] ">
              <a
                href="/#contact"
                className="hover:text-orange-600"
                onClick={(e) => {
                  e.preventDefault();
                  navigate('/#contact');
                  toggleMobileMenu();
                }}
              >
                Contact Us
              </a>
            </li>
            <li className="bg-[#f9d598] px-2 py-1 rounded-[10px]">
              <a
                href="https://www.zeffy.com/en-US/donation-form/24b738b0-cf34-482f-a60d-769449ff1f77"
                className="hover:text-orange-600"
                onClick={(e) => {
                  e.preventDefault();
                  window.location.href =
                    'https://www.zeffy.com/en-US/donation-form/24b738b0-cf34-482f-a60d-769449ff1f77';
                }}
              >
                Donate
              </a>
            </li>
          </ul>
        </div>
      )}

      <div className="bg-[#C9471A] p-2 text-white w-full overflow-hidden">
        <div className="flex items-center">
          <span className="font-bold px-2 md:px-4 text-[12px] md:text-[16px] bg-[#FFBF70] text-white rounded-md">
            Announcements
          </span>
          <p className="ml-1 text-[10px]">:</p>
          <div className="overflow-hidden w-full">
            <div className="flex animate-scrollMobile md:animate-scrollDesktop">
              <p className="whitespace-nowrap mx-4 min-w-fit">
                SunderKaand Paath on Saturday 6:00 - 8:00PM followed by
                MahaAarti and MahaPrasad.
              </p>
              <p className="whitespace-nowrap mx-4 min-w-fit">
                सुंदरकांड पाठ शनिवार को शाम 6:00 - 8:00 बजे, उसके बाद महाआरती और
                महाप्रसाद.
              </p>
              <p className="whitespace-nowrap mx-4 min-w-fit">
                સુંદરકાંડ પાઠ શનિવારે સાંજે 6:00 - 8:00 વાગ્યે, ત્યારબાદ મહાઆરતી
                અને મહાપ્રસાદ.
              </p>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
